import React from "react";
import T from "prop-types";
import { StatusTag } from "MODULES/shared/components";

function Consignment({ lineItems }) {
  const asIsItem = lineItems.find(l => l.as_is);

  if (asIsItem) {
    return (
      <StatusTag key="warning" title="Sold As-Is" icon="exclamation-triangle" />
    );
  }

  return null;
}

Consignment.propTypes = {
  lineItems: T.arrayOf(
    T.shape({
      as_is: T.bool
    })
  ).isRequired
};

export default Consignment;



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Warnings/AsIs.jsx